import React, { useEffect, useRef, useState } from 'react';
import './SemanaDropdown.css';

const SEMANA_OPTIONS = [
  { value: '', label: 'Semanas', className: 'semana-todas' },
  { value: 'Semana 1', label: 'SEMANA 1', className: 'semana-1' },
  { value: 'Semana 2', label: 'SEMANA 2', className: 'semana-2' },
  { value: 'Semana 3', label: 'SEMANA 3', className: 'semana-3' },
  { value: 'Semana 4', label: 'SEMANA 4', className: 'semana-4' },
  { value: 'Semana 5', label: 'SEMANA 5', className: 'semana-5' },
  { value: 'Semana 6', label: 'SEMANA 6', className: 'semana-6' },
  { value: 'Semana 7', label: 'SEMANA 7', className: 'semana-7' },
  { value: 'Semana 8', label: 'SEMANA 8', className: 'semana-8' }
];

function SemanaDropdown({ value, onChange, disabled = false }) {
  const [open, setOpen] = useState(false);
  const [activeIndex, setActiveIndex] = useState(0);
  const wrapperRef = useRef(null);
  const triggerRef = useRef(null);
  const optionRefs = useRef([]);

  const selectedIndex = SEMANA_OPTIONS.findIndex((option) => option.value === value);
  const selectedOption = selectedIndex >= 0 ? SEMANA_OPTIONS[selectedIndex] : SEMANA_OPTIONS[0];
  const label = selectedOption.label;

  useEffect(() => {
    if (disabled && open) setOpen(false);
  }, [disabled, open]);

  useEffect(() => {
    if (!open) return;
    setActiveIndex(selectedIndex >= 0 ? selectedIndex : 0);
  }, [open, selectedIndex]);

  useEffect(() => {
    if (!open) return;
    const node = optionRefs.current[activeIndex];
    if (node) node.focus();
  }, [open, activeIndex]);

  useEffect(() => {
    if (!open) return;

    const handleOutside = (event) => {
      if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
        setOpen(false);
      }
    };

    const handleKey = (event) => {
      if (event.key === 'Escape') {
        event.preventDefault();
        setOpen(false);
        requestAnimationFrame(() => triggerRef.current?.focus());
        return;
      }

      const focusInside = wrapperRef.current?.contains(document.activeElement);
      if (!focusInside) return;

      if (event.key === 'ArrowDown') {
        event.preventDefault();
        setActiveIndex((prev) => (prev + 1) % SEMANA_OPTIONS.length);
      }

      if (event.key === 'ArrowUp') {
        event.preventDefault();
        setActiveIndex((prev) => (prev - 1 + SEMANA_OPTIONS.length) % SEMANA_OPTIONS.length);
      }

      if (event.key === 'Enter') {
        event.preventDefault();
        const option = SEMANA_OPTIONS[activeIndex];
        if (option) {
          onChange?.(option.value);
          setOpen(false);
          requestAnimationFrame(() => triggerRef.current?.focus());
        }
      }
    };

    document.addEventListener('mousedown', handleOutside);
    document.addEventListener('touchstart', handleOutside);
    document.addEventListener('keydown', handleKey);

    return () => {
      document.removeEventListener('mousedown', handleOutside);
      document.removeEventListener('touchstart', handleOutside);
      document.removeEventListener('keydown', handleKey);
    };
  }, [open, activeIndex, onChange]);

  const handleBlur = (event) => {
    if (!wrapperRef.current?.contains(event.relatedTarget)) {
      setOpen(false);
    }
  };

  const handleToggle = () => {
    if (disabled) return;
    setOpen((prev) => !prev);
  };

  const handleSelect = (option) => {
    onChange?.(option.value);
    setOpen(false);
    requestAnimationFrame(() => triggerRef.current?.focus());
  };

  return (
    <div
      className={`semana-dropdown ${open ? 'is-open' : ''}`}
      ref={wrapperRef}
      onBlur={handleBlur}
    >
      <button
        type="button"
        className="semana-trigger"
        onClick={handleToggle}
        aria-haspopup="listbox"
        aria-expanded={open}
        aria-disabled={disabled}
        disabled={disabled}
        ref={triggerRef}
      >
        <span className="semana-trigger-text">{label}</span>
        <span className="semana-trigger-sep">|</span>
        <span className="semana-trigger-caret">▼</span>
      </button>

      {open ? (
        <div className="semana-menu" role="listbox" aria-label="Selecionar semana">
          {SEMANA_OPTIONS.map((option, index) => (
            <button
              key={option.value || 'TODAS'}
              type="button"
              role="option"
              aria-selected={value === option.value}
              className={`semana-option ${option.className} ${value === option.value ? 'is-selected' : ''}`}
              onClick={() => handleSelect(option)}
              ref={(el) => {
                optionRefs.current[index] = el;
              }}
            >
              {option.label}
            </button>
          ))}
        </div>
      ) : null}
    </div>
  );
}

export default SemanaDropdown;
